import {
	PUB_SUB_EVENTS,
	QuantityChangeEvent,
	subscribe,
} from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { type ProductInfo } from '@/scripts/product/product-info'

export class SellingPlan extends UcoastEl {
	static htmlSelector = 'selling-plan'
	static selectors = {
		disclaimer: '[data-uc-subscription-quantity-disclaimer]',
	}
	static DISCLAIMER_THRESHOLD = 3

	productId: string
	info?: ProductInfo
	sellingPlanInput: HTMLInputElement
	tbybInput: HTMLInputElement
	sellingPlanOptions: NodeListOf<HTMLButtonElement>
	source: string

	constructor() {
		super()
		this.source = q.ra(this, 'data-uc-selling-plan-source')
		this.productId = q.ra(this, 'data-uc-selling-plan-product')
		this.info = q.os(
			`product-info[data-uc-product-id="${this.productId}"][data-uc-product-info-source=${this.source}], product-sticky-cta[data-uc-product-id="${this.productId}"][data-uc-product-info-source=${this.source}]`
		)
		this.sellingPlanInput = q.rs('input[name="selling_plan"]', this)
		this.tbybInput = q.rs('input[name="tbyb"]', this)
		this.sellingPlanOptions = q.rl('[data-uc-selling-plan-id]', this)
		this.onSelectOption = this.onSelectOption.bind(this)
		subscribe(
			PUB_SUB_EVENTS.quantityValueUpdate,
			this.onQuantityValueUpdate.bind(this)
		)
	}

	onQuantityValueUpdate(event: QuantityChangeEvent) {
		const {
			data: { quantity },
		} = event
		const disclaimer = q.os(SellingPlan.selectors.disclaimer, this)

		if (quantity >= SellingPlan.DISCLAIMER_THRESHOLD) {
			disclaimer?.style.setProperty('display', 'block')
		} else {
			disclaimer?.style.setProperty('display', 'none')
		}
	}

	override connectedCallback() {
		super.connectedCallback()
		this.sellingPlanOptions.forEach((option) => {
			option.addEventListener('click', this.onSelectOption)
		})
	}

	override disconnectedCallback() {
		this.sellingPlanOptions?.forEach((option) => {
			option.removeEventListener('click', this.onSelectOption)
		})
	}

	onSelectOption(event: Event) {
		event.preventDefault()
		const currentTarget = q.rct(event)
		const sellingPlanId = q.ra(currentTarget, 'data-uc-selling-plan-id')

		this.sellingPlanInput.value =
			sellingPlanId === 'otp' ? '' : sellingPlanId
		this.sellingPlanOptions.forEach((option) =>
			option.classList.remove('active')
		)
		currentTarget.classList.add('active')

		const tbybPresentation = q.oa(currentTarget, 'data-tbyb-presentation')
		if (tbybPresentation) {
			this.tbybInput.value = tbybPresentation
			const tbybOptions = q.ol<HTMLLabelElement>(
				'label[data-refill-variant-option]'
			)

			tbybOptions?.forEach((option) => {
				if (
					option.getAttribute('data-refill-variant-option') ===
					tbybPresentation
				) {
					option.click()
				}
			})
		}

		if (!this.info?.siblingForm) {
			return
		}

		const siblingFormSellingPlan = q.os<SellingPlan>(
			'selling-plan',
			this.info.siblingForm
		)
		if (!siblingFormSellingPlan) {
			return
		}
		siblingFormSellingPlan.sellingPlanInput.value =
			this.sellingPlanInput.value
		siblingFormSellingPlan.sellingPlanOptions?.forEach((option) =>
			option.classList.remove('active')
		)
		const siblingCurrentTarget = q.os(
			`[data-uc-selling-plan-id="${sellingPlanId}"]`,
			siblingFormSellingPlan
		)
		if (!siblingCurrentTarget) return
		siblingCurrentTarget.classList.add('active')
	}
}
